var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NodeContainer',{attrs:{"business-adapter":_vm.businessAdapter,"node-data":_vm.nodeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }